import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

import * as  Objects from '@core/objects';

import { VersionFeedback } from '@core/models/version-feedback';
import { VersionShare, VersionShareStatus, FeedbackStatusCodeEnum } from '@core/models/version-share.model';

@Component({
    selector: 'core-versions-completed-box',
    templateUrl: './completed-box.component.html',
    styleUrls: ['./completed-box.component.scss']
})
export class VersionsCompletedBoxComponent implements OnInit, OnChanges {
    
    public readonly FEEDBACK_STATUS = FeedbackStatusCodeEnum;
    @Input() version: Objects.Version;
    @Input() feedback: VersionFeedback;
    @Input() versionShare: VersionShare = null;

    @Output() actionComplete = new EventEmitter<any>();

    public feedbackStatus: VersionShareStatus;

    constructor( ) { }

    ngOnInit() {
        this.setCurrentFeedbackStatus();
       
    }
    ngOnChanges(changes: SimpleChanges): void {
        if(changes.versionShare || changes.feedback){
            this.setCurrentFeedbackStatus();
        }
    }

    onComplete(event: any){
        this.actionComplete.emit(event);
    }

    private setCurrentFeedbackStatus() {
        if(this.feedback != null){
            this.feedbackStatus = this.feedback.status;
        }
        if(this.versionShare != null){
            this.feedbackStatus = this.versionShare.status;
        }
    }


}
